module.exports = __webpack_public_path__ + "static/media/feature_list1.bd690ca1.png";